import Table from './table';
import mapProps from '../scripts/utils/map-props';

export default mapProps([
  {
    name: 'selectedRowKeys',
    event: ['selectedChange', 'update:selectedRowKeys'],
  },
  'expandedRowKeys',
])(Table);
